import { v4 as uuid } from 'uuid';

import { EnqueueSnackbarNotificationReducer } from './types';

export const enqueueSnackbarNotificationReducer: EnqueueSnackbarNotificationReducer =
  (state, action) => {
    const notification = action.payload;
    const key = notification.options?.key;

    return {
      ...state,
      notifications: [
        ...state.notifications,
        {
          ...notification, //
          key: key || uuid(),
        },
      ],
    };
  };
